import { Routes, Route, Navigate } from 'react-router-dom';

import LoginScreen from '@/feature/auth/components/LoginScreen';

import AuditTrailPage from '../components/AuditTrail/AuditTrailPage';
import DashboardPage from '../components/Dashboard/DashboardPage';
import DevicesPage from '../components/Devices/DevicesPage';
import HelpDeskPage from '../components/HelpDesk/HelpDeskPage';
import Layout from '../components/Layout/Layout';
import OrganizationDetailsPage from '../components/Organizations/OrganizationDetailsPage';
import OrganizationsPage from '../components/Organizations/OrganizationsPage';
import { TokenUsageOrgDetailsPage } from '../components/TokenUsage/TokenUsageOrgDetailsPage';
import TokenUsagePage from '../components/TokenUsage/TokenUsagePage';
import UserDetailsPage from '../components/Users/UserDetailsPage';
import UsersPage from '../components/Users/UsersPage';

import ProtectedRoute from './ProtectedRoute';
import { ROUTES } from './routeConstants';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path={ROUTES.LOGIN} element={<LoginScreen />} />
      <Route element={<ProtectedRoute />}>
        <Route path={ROUTES.ROOT} element={<Layout />}>
          <Route index element={<Navigate to={ROUTES.DASHBOARD} replace />} />
          <Route path='dashboard' element={<DashboardPage />} />
          <Route path='organizations' element={<OrganizationsPage />} />
          <Route path='organizations/:id' element={<OrganizationDetailsPage />} />
          <Route path='devices' element={<DevicesPage />} />
          <Route path='users' element={<UsersPage />} />
          <Route path='users/:id' element={<UserDetailsPage />} />
          <Route path='token-usage' element={<TokenUsagePage />} />
          <Route path='token-usage/:orgId' element={<TokenUsageOrgDetailsPage />} />
          <Route path='audit-trail' element={<AuditTrailPage />} />
          <Route path='help-desk' element={<HelpDeskPage />} />
        </Route>
      </Route>
      <Route path='*' element={<Navigate to={ROUTES.LOGIN} replace />} />
    </Routes>
  );
};

export default AppRoutes;
